import { MainTableFilterModel } from '../../shared/models/main-table-filter.model';

export class LoadPermitToWorkTable {
  static readonly type = '[PermitToWork] Load table';
  constructor(public filter: MainTableFilterModel) {}
}
